import * as Yup from 'yup'
//export type ForgotValues = {
//email: string
//}

export type ForgotValues = {
  phone: string
  country_code: string
}
export type NewPassValues = {
  code: string
  password: string
}
//export const ForgotSchema = Yup.object().shape({
//email: Yup.string().required('Required'),
//})

export const ForgotSchema = Yup.object().shape({
  phone: Yup.string().required('Required'),
  country_code: Yup.string().required('Required'),
})
export const NewPassSchema = Yup.object().shape({
  code: Yup.string().min(4).max(4).required('Required'),
  password: Yup.string()
    .min(6, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
})
